export class LiveIssueFormsApi {
  constructor(projectId, util) {
    this.projectId = projectId;
    this.util = util;
  }
  async getIssueFormsInfo() {
    return this.util.get(`/api/cloud/createissue/project/${this.projectId}/forms`);
  }
}